import { ArticleEdgesOverlay } from 'app/modules/wallforming/components/scenes/objects/articles/ArticleEdgesOverlay';
import { ArticlesHandlerFactory } from 'app/modules/wallforming/components/scenes/objects/articles/ArticlesHandlerFactory';
import { BatchedMeshHandler } from 'app/modules/wallforming/components/scenes/objects/articles/BatchedMeshHandler';
import { NavigatorBatchedMeshHandler } from 'app/modules/wallforming/components/scenes/objects/articles/NavigatorBatchedMeshHandler';
import { PivotControlsContainer } from 'app/modules/wallforming/components/scenes/tools/pivot-controls/PivotControlsContainer';
import { QuickPanelReplacement } from 'app/modules/wallforming/components/scenes/tools/quick-panel-replacement/QuickPanelReplacement';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface ArticlesContainerProps {
    isMainCanvas: boolean;
}

export const Articles = ({ isMainCanvas }: ArticlesContainerProps) => {
    const isPanelQuickReplacementOpen = usePlacementStore((state) => state.isPanelQuickReplacementOpen);
    return (
        <>
            {isMainCanvas ? <BatchedMeshHandler /> : <NavigatorBatchedMeshHandler />}

            <ArticlesHandlerFactory isMainCanvas={isMainCanvas} />

            {isMainCanvas && (
                <>
                    <ArticleEdgesOverlay />
                    {isPanelQuickReplacementOpen && <QuickPanelReplacement />}
                    <PivotControlsContainer />
                </>
            )}
        </>
    );
};
